import React, { useState } from 'react';
import {
    CardElement,
    useStripe,
    useElements
} from '@stripe/react-stripe-js';

import Paiements_Class from '../class/Paiements_Class';
import Func from '../class/Func';
import { useNavigate } from 'react-router-dom';

function AddCardForm() {

    const stripe = useStripe();
    const elements = useElements();

    const navigate = useNavigate()

    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!stripe || !elements) {
            console.log("Stripe pas prêt !");
            return;
        }

        setLoading(true);

        // 1. Appel au backend pour créer un SetupIntent

        const res = await Paiements_Class.post("setupIntent", {});

        const clientSecret = res.clientSecret

        // 2. Confirmer la carte côté client
        const cardElement = elements.getElement(CardElement);

        const result = await stripe.confirmCardSetup(clientSecret, {
            payment_method: {
                card: cardElement,
            },
        });

        if (result.error) {
            setMessage(result.error.message);
        } else {

            Func.setFlash("Carte ajoutée avec succès !")

            navigate('/mon-profile/paiements')

            // setMessage("Carte ajoutée avec succès !");
        }

        setLoading(false);
    };

    return (
        <form onSubmit={handleSubmit} style={{ maxWidth: 400, margin: "0 auto", textAlign: "center" }}>
            <h2 className='mb20'>Ajouter une carte</h2>

            <div style={{ padding: "10px", border: "1px solid #ccc", marginBottom: 10 }}>
                <CardElement />
            </div>

            <button disabled={!stripe || loading} className='btn bg3 cl1 brc3 brc1solid mt20'>
                {loading ? "Ajout..." : "Ajouter la carte"}
            </button>

            {message && <p>{message}</p>}
        </form>
    );
}

export default AddCardForm;